import { Controller } from "@hotwired/stimulus"

// Caché global de notas para evitar llamadas repetidas a la API
// La caché persiste mientras el usuario esté en la página
const notasCache = new Map()
const CACHE_TTL_MS = 5 * 60 * 1000 // 5 minutos de TTL

export default class extends Controller {
  static targets = ["contenedor"]
  static values = { ticketId: Number }

  connect() {
    // TicketNotasController connected
  }

  load() {
    if (!this.hasContenedorTarget || !this.hasTicketIdValue) {
      console.warn("Faltan targets o valores")
      return
    }

    const card = this.element.closest(".zoomed")
    if (!card) {
      console.log("La tarjeta no está activa (zoomed), se omite fetch de notas.")
      return
    }

    const ticketId = this.ticketIdValue
    const cached = notasCache.get(ticketId)
    
    // Verificar si hay caché válida
    if (cached && (Date.now() - cached.timestamp < CACHE_TTL_MS)) {
      console.log("📦 Usando notas cacheadas para ticket ID:", ticketId)
      this.contenedorTarget.innerHTML = cached.html
      return
    }

    console.log("📥 Cargando notas para ticket ID:", ticketId)

    fetch(`/apps/home-repairs/tickets/${ticketId}/notas`, {
      headers: { "Accept": "text/html" }
    })
      .then(response => response.text())
      .then(html => {
        // Guardar en caché
        notasCache.set(ticketId, {
          html: html,
          timestamp: Date.now()
        })
        console.log("💾 Notas cacheadas para ticket ID:", ticketId)
        this.contenedorTarget.innerHTML = html
      })
      .catch(error => {
        console.error("❌ Error al cargar notas:", error)
        this.contenedorTarget.innerHTML = "<p class='text-sm text-red-500'>No se pudieron cargar las notas.</p>"
      })
  }
  
  // Método para invalidar caché de un ticket específico (útil después de crear una nota)
  static invalidateCache(ticketId) {
    notasCache.delete(ticketId)
    console.log("🗑️ Caché invalidada para ticket ID:", ticketId)
  }
  
  // Método para limpiar toda la caché
  static clearCache() {
    notasCache.clear()
    console.log("🗑️ Caché de notas limpiada completamente")
  }
}